import { CreditCardFieldNames } from "checkout-query-client/types/chex-form-fields";
import { FormConfig, InputType } from "checkout-query-client/types/form-types";
import {
  expirationMonths,
  expirationYears,
} from "checkout-query-client/utils/helpers";

export const creditCardFormConfig: FormConfig<CreditCardFieldNames> = {
  active: true,
  title: "Credit or Debit Card",
  inputs: [
    {
      id: "nameOnCard",
      type: InputType.text,
      initialValue: "",
      active: true,
      autocomplete: "cc-name",
      grid: {
        small: {},
        medium: {},
        large: {},
      },
    },
    {
      id: "cardNumber",
      type: InputType.cardNumber,
      autocomplete: "cc-number",
      initialValue: "",
      active: true,
      grid: {
        small: {
          minWidth: "100%",
          flex: "1",
        },
        medium: {
          minWidth: "100%",
          flex: "1",
        },
        large: {
          minWidth: "40%",
          flex: "0.5",
        },
      },
    },
    {
      id: "expiration",
      type: InputType.text,
      initialValue: "",
      active: true,
      autocomplete: "cc-exp",
      grid: {
        small: {
          minWidth: "100%",
          flex: "1",
        },
        medium: {
          minWidth: "50%",
          flex: "0.5",
        },
        large: {
          minWidth: "20%",
          flex: "0.25",
        },
      },
    },
    {
      id: "expirationMonth",
      type: InputType.select,
      initialValue: "",
      active: true,
      options: expirationMonths,
      autocomplete: "cc-exp-month",
      grid: {
        small: {
          minWidth: "40%",
          flex: "0.5",
        },
        medium: {
          minWidth: "20%",
          flex: "0.25",
        },
        large: {
          minWidth: "12%",
          flex: "0.125",
        },
      },
    },
    {
      id: "expirationYear",
      type: InputType.select,
      initialValue: "",
      active: true,
      isEmptyLabel: true,
      options: expirationYears,
      autocomplete: "cc-exp-year",
      grid: {
        small: {
          minWidth: "40%",
          flex: "0.5",
        },
        medium: {
          minWidth: "20%",
          flex: "0.25",
        },
        large: {
          minWidth: "12%",
          flex: "0.125",
        },
      },
    },
    {
      id: "securityCode",
      type: InputType.securityCode,
      initialValue: "",
      active: true,
      autocomplete: "cc-csc",
      grid: {
        small: {
          minWidth: "100%",
          flex: "1",
        },
        medium: {
          minWidth: "40%",
          flex: "0.5",
        },
        large: {
          minWidth: "20%",
          flex: "0.25",
        },
      },
    },
    {
      id: "selectNetwork",
      type: InputType.selectNetwork,
      initialValue: "",
      active: true,
      grid: {
        small: {
          minWidth: "100%",
          flex: "1",
        },
        medium: {
          minWidth: "100%",
          flex: "1",
        },
        large: {
          minWidth: "100%",
          flex: "1",
        },
      },
    },
    {
      id: "billingTitle",
      type: InputType.subTitle,
      active: true,
      grid: {
        small: {
          marginTop: "2",
        },
        medium: {
          marginTop: "2",
        },
        large: {
          marginTop: "2",
        },
      },
    },
    {
      id: "doAddressesMatch",
      type: InputType.checkbox,
      initialValue: "true",
      active: true,
      grid: {
        small: {},
        medium: {},
        large: {},
      },
    },
    {
      id: "currentShippingAddress",
      type: InputType.currentAddress,
      initialValue: "",
      active: true,
      grid: {
        small: {
          marginTop: "-2",
          marginBottom: "2",
        },
        medium: {
          marginTop: "-2",
          marginBottom: "2",
        },
        large: {
          marginTop: "-2",
          marginBottom: "2",
        },
      },
    },
    {
      id: "billingAddressName",
      type: InputType.text,
      initialValue: "",
      active: true,
      autocomplete: "cc-name",
      grid: {
        small: {},
        medium: {},
        large: {},
      },
    },
    {
      id: "billingAddressCountry",
      type: InputType.select,
      initialValue: "US",
      active: true,
      autocomplete: "country-name",
      grid: {
        small: {},
        medium: {},
        large: {},
      },
    },
    {
      id: "billingAddressAddressLine1",
      type: InputType.autocomplete,
      initialValue: "",
      active: true,
      autocomplete: "address-line1",
      grid: {
        small: {},
        medium: {},
        large: {},
      },
    },
    {
      id: "billingAddressAddressLine2",
      type: InputType.text,
      initialValue: "",
      active: true,
      autocomplete: "address-line2",
      grid: {
        small: {},
        medium: {},
        large: {},
      },
    },
    {
      id: "billingAddressCity",
      type: InputType.text,
      initialValue: "",
      autocomplete: "address-level2",
      active: true,
      grid: {
        small: {},
        medium: {},
        large: {},
      },
    },
    {
      id: "billingAddressAdministrativeArea",
      type: InputType.dynamic,
      initialValue: "",
      autocomplete: "address-level1",
      active: true,
      grid: {
        small: {
          flex: "0.5",
        },
        medium: {
          flex: "0.5",
        },
        large: {
          flex: "0.5",
        },
      },
    },
    {
      id: "billingAddressZip",
      type: InputType.text,
      initialValue: "",
      autocomplete: "postal-code",
      active: true,
      grid: {
        small: {
          flex: "0.5",
        },
        medium: {
          flex: "0.5",
        },
        large: {
          flex: "0.5",
        },
      },
    },
    {
      id: "collectConsentToStoreForFuturePayments",
      type: InputType.consentCheckbox,
      initialValue: "false",
      active: false,
      grid: {
        small: {},
        medium: {},
        large: {},
      },
    },
    {
      id: "setAsDefault",
      type: InputType.checkbox,
      initialValue: "false",
      active: false,
      grid: {
        small: {},
        medium: {},
        large: {},
      },
    },
  ],
};
